import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForWhoSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4" style={{
    background: 'var(--color-bg)'
  }} data-id="element-116">
      <div className="max-w-2xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} className="text-center mb-14" data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-black leading-tight" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-119">
            ¿Para Quién Es Esto?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-120">
          {/* For you */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          delay: 0.2,
          duration: 0.7
        }} data-id="element-121">
            <div className="p-8 rounded-sm h-full" style={{
            background: 'var(--color-surface)',
            border: '1px solid var(--color-accent)'
          }} data-id="element-122">
              <p className="text-lg font-black mb-6" style={{
              color: 'var(--color-accent)',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-123">
                🎯 Esto es para ti si…
              </p>
              <div className="space-y-4" data-id="element-124">
                <div className="flex items-start gap-3" data-id="element-125">
                  <CheckIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                  color: 'var(--color-accent)'
                }} data-id="element-126" />
                  <p className="text-base leading-relaxed" style={{
                  color: 'var(--color-text)'
                }} data-id="element-127">
                    Sientes que tienes potencial que no has explotado — y estás
                    harto de sentirlo sin movilizarlo
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-128">
                  <CheckIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                  color: 'var(--color-accent)'
                }} data-id="element-129" />
                  <p className="text-base leading-relaxed" style={{
                  color: 'var(--color-text)'
                }} data-id="element-130">
                    Sabes que puedes ganar más dinero, pero algo interno siempre
                    interfiere en el momento crítico
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-131">
                  <CheckIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                  color: 'var(--color-accent)'
                }} data-id="element-132" />
                  <p className="text-base leading-relaxed" style={{
                  color: 'var(--color-text)'
                }} data-id="element-133">
                    Quieres profundidad real, no motivación superficial que dura
                    48 horas
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-134">
                  <CheckIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                  color: 'var(--color-accent)'
                }} data-id="element-135" />
                  <p className="text-base leading-relaxed" style={{
                  color: 'var(--color-text)'
                }} data-id="element-136">
                    Buscas integrar tu crecimiento espiritual con tu expansión
                    financiera — sin que una sabotee a la otra
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-137">
                  <CheckIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                  color: 'var(--color-accent)'
                }} data-id="element-138" />
                  <p className="text-base leading-relaxed" style={{
                  color: 'var(--color-text)'
                }} data-id="element-139">
                    Estás listo para dejar de consumir y empezar a transformarte
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Not for you */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          delay: 0.4,
          duration: 0.7
        }} data-id="element-140">
            <div className="p-8 rounded-sm h-full" style={{
            background: 'var(--color-surface)',
            border: '1px solid var(--color-border)'
          }} data-id="element-141">
              <p className="text-lg font-black mb-6" style={{
              color: 'var(--color-text-muted)',
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-142">
                🚫 Esto NO es para ti si…
              </p>
              <div className="space-y-4" data-id="element-143">
                <div className="flex items-start gap-3" data-id="element-144">
                  <XIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                  color: '#ef4444'
                }} data-id="element-145" />
                  <p className="text-base leading-relaxed" style={{
                  color: 'var(--color-text-muted)'
                }} data-id="element-146">
                    Buscas la solución mágica que no requiere trabajo interno
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-147">
                  <XIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                  color: '#ef4444'
                }} data-id="element-148" />
                  <p className="text-base leading-relaxed" style={{
                  color: 'var(--color-text-muted)'
                }} data-id="element-149">
                    Quieres entretenimiento empaquetado como crecimiento
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-150">
                  <XIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                  color: '#ef4444'
                }} data-id="element-151" />
                  <p className="text-base leading-relaxed" style={{
                  color: 'var(--color-text-muted)'
                }} data-id="element-152">
                    Prefieres seguir culpando al mercado, a la economía, a la
                    suerte
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-153">
                  <XIcon className="w-5 h-5 mt-0.5 flex-shrink-0" style={{
                  color: '#ef4444'
                }} data-id="element-154" />
                  <p className="text-base leading-relaxed" style={{
                  color: 'var(--color-text-muted)'
                }} data-id="element-155">
                    No estás dispuesto a cuestionarte lo que llevas años
                    creyendo sobre ti mismo
                  </p>
                </div>
              </div>
              <p className="text-sm italic mt-6" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-156">
                Y eso está bien. Pero este no es tu lugar.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}